

export function generateVoice(text, voiceSpeed=2, lang="ja"){
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = lang;
    //utterance.voice = voices[0];
    utterance.rate = voiceSpeed;
    return utterance
}

export function speakVoice(utterance){
    window.speechSynthesis.speak(utterance);
}

export function speak(text, voiceSpeed, lang){
    const utterance = generateVoice(text, voiceSpeed, lang);
    speakVoice(utterance);
}
